import { useContext } from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate
} from "react-router-dom";
import { UserContext } from "./components/context/UserContext";
import Login from "./components/login/login";
import MutualFund from "./components/mutualFund/mutualFund";
import Sidebar from "./components/sidebar/sidebar";
import Cron from "./components/cron/cron"
import Home from "./components/home/home";
import MutualFundNav from "./components/mutualFundNav/mutualFunNav";
import Portfolio from "./components/portfolio/portfolio";
import Transactions from "./components/portfolio/transaction";
export default function AppWithRoutes(props) {
    const [user, setUser] = useContext(UserContext);

    return <BrowserRouter>
        <Sidebar>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="login" element={<Login />} />
                <Route path="mf" element={<MutualFund />} />
                <Route path="mfnav" element={<MutualFundNav />} />
                <Route path="portfolio" element={<Portfolio />} />
                <Route path="portfolio/:mfId" element={<Transactions />} />
                <Route path="cron" element={<Cron />} />
            </Routes>
        </Sidebar>

    </BrowserRouter>

}